// extracted by mini-css-extract-plugin
export default {"container":"recomendations_container__YJnoc","recomendations":"recomendations_recomendations__KB9la","cards":"recomendations_cards__qwQT7"};